import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { PurchasedNumberFormatter } from '@phone-number/services/formatter/PurchasedNumberFormatter';
import { BuyNumberFormatter } from '@phone-number/services/formatter/BuyNumberFormatter';

class NumberServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  checkNumber(number) {
    return this.http.post('validate', { number });
  }

  getList(params) {
    return this.http
      .get('purchased', { params: params })
      .then(res => PurchasedNumberFormatter.formatItemWithPaginate(res));
  }

  getSelect(params) {
    return this.http.get('select', { params: params });
  }

  getSelectByUserId(user_id, params) {
    return this.pure_http.get(`/users/${user_id}/phones/select`, { params });
  }

  addUserNumber(params) {
    return this.http.post(`/custom-numbers`, params);
  }

  buy(id) {
    return this.http.post(`/integration/buy/number/${id}`);
  }

  getBuyList(country_iso_code, type, region = null) {
    return this.http
      .post('/integration/data', {
        countryIsoCode: [country_iso_code],
        type: type,
        region: region
      })
      .then(res => BuyNumberFormatter.formatItemWithPaginate(res));
  }

  deactivate(id) {
    return this.http.patch(`/${id}/deactivate`);
  }

  connectPBX(id) {
    return this.pure_http.post(`pbx/numbers/${id}/use`);
  }
}

export const NumberService = new NumberServiceClass({
  api_version: 2,
  resource: 'phones'
});
